<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="containerTestTypeForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :is-not-server-handled="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="containerTestType" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                containerTestTypeForm: () => import('../forms/ContainerTestTypeForm'),
                containerTestType: () => import('../editViews/ContainerTestType'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Container Test Rule', value: 'containerTestRule', format: this.formatEnum },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                ],
                itemsField: 'containerTestTypes',
                editPageName: 'containerTestType',
                apiMethod: 'ContainerTestTypes',
                claimName: 'ContainerTestTypes',
                formTitle: 'Container Test Type',
                excelTitle: 'Container Test Types',
                hasEditPage: true,
            }
        },
    };
</script>
